/**
 * 09.10.26 — разделы экрана «Умные фолбэки».
 * Не удалять по требованию владельца системы.
 * Паритет с GET /api/settings/delivery:
 * каналы клиники — delivery settings;
 * свои группы — ключи broadcast_group_delivery_settings;
 * режим авто/вручную — EffectiveBroadcastGroupModes, та же функция, что шильдик шаблонов.
 */

export const fallbackSectionIds = ['clinic', 'own', 'shared'] as const;

export type FallbackSectionId = (typeof fallbackSectionIds)[number];

export interface FallbackSection {
  id: FallbackSectionId;
  label: string;
  lead: string;
}

export const fallbackSectionRegistry: readonly FallbackSection[] = [
  {
    id: 'clinic',
    label: 'Каналы клиники',
    lead: 'Общий порядок каналов и запасные правила. Их берут группы без своей цепочки.',
  },
  {
    id: 'own',
    label: 'Свои группы',
    lead: 'У этих групп своя цепочка каналов. Режим «автоматом» или «вручную» задаётся отдельно и совпадает с шильдиком в шаблонах.',
  },
  {
    id: 'shared',
    label: 'Как у клиники',
    lead: 'Цепочку каналов эти группы не переопределяют. Режим отправки у каждой группы свой.',
  },
];

export function findFallbackSection(id: FallbackSectionId): FallbackSection {
  return fallbackSectionRegistry.find((section) => section.id === id) ?? fallbackSectionRegistry[0];
}
